import { Config } from "services/Config";
import { get } from "services/Helper";

const normalizeCountryCode = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  const normalizedCountryCode = value.toUpperCase().trim();
  return /^[A-Z]{2}$/.test(normalizedCountryCode) ? normalizedCountryCode : "";
};

export class LocationContextService {
  static fetchLocationContext = () => get(Config.getLocationContextUrl());

  static parseLocationContext = (payload) => {
    const estimatedCountry = normalizeCountryCode(
      payload?.estimated_country
      || payload?.country
      || payload?.market?.country
      || payload?.location?.country
      || ""
    );

    const countrySource = typeof payload?.country_source === "string"
      ? payload.country_source
      : "";

    return {
      estimated_country: estimatedCountry,
      country_source: countrySource,
    };
  };

  static getEstimatedCountry = async () => {
    const locationContext = await this.fetchLocationContext();
    return this.parseLocationContext(locationContext);
  };
}
